module.exports = __webpack_public_path__ + "static/img/homenew1.dfb4dbc3.png";